import React, { ChangeEvent } from 'react';
import { Stack } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import 'dayjs/locale/es';
import { FormikTouched } from 'formik/dist/types';
import { TimeValidationError } from '@mui/x-date-pickers/models';
import { PickerChangeHandlerContext } from '@mui/x-date-pickers/internals/hooks/usePicker/usePickerValue.types';

type Props = {
    label: string;
    name: string;
    size?: undefined | 'small' | 'medium';
    margin?: 'dense' | 'normal' | 'none';
    required?: false | boolean;
    value?: any;
    touched?: boolean | FormikTouched<any> | FormikTouched<any>[] | undefined;
    errors?: any;
    minTime?: any;
    maxTime?: any;
    disabled?: boolean;
    disablePast?: boolean;
    disableFuture?: boolean;
    onChange: (
        value: ChangeEvent<HTMLInputElement> | null,
        context: PickerChangeHandlerContext<TimeValidationError>
    ) => void;
};

const TimePickerField = ({
    label,
    name,
    touched,
    errors,
    minTime = undefined,
    maxTime = undefined,
    disabled,
    disablePast = false,
    disableFuture = false,
    onChange,
    required,
    size,
    value,
}: Props) => {
    //onChange Formik
    //The variable timeVariableFormik must be equal to the variable name of the formik
    //onChange={(value) => formik.setFieldValue('timeVariableFormik', value, true)}

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
            <Stack component="div">
                <TimePicker
                    label={label}
                    value={value || null}
                    disabled={disabled}
                    disablePast={disablePast}
                    disableFuture={disableFuture}
                    ampm={true}
                    minTime={minTime}
                    maxTime={maxTime}
                    onChange={onChange}
                    slotProps={{
                        textField: {
                            name: name,
                            size: size,
                            required: required,
                            error: touched && Boolean(errors),
                            helperText: touched ? errors : '',
                        },
                    }}
                    viewRenderers={{
                        hours: renderTimeViewClock,
                        minutes: renderTimeViewClock,
                        seconds: renderTimeViewClock,
                    }}
                />
            </Stack>
        </LocalizationProvider>
    );
};

export default TimePickerField;
